import { createSlice } from '@reduxjs/toolkit';
import { NotificationInterface } from '../../types/notification';

interface NotificationState {
  count: number | string;
  notification: NotificationInterface;
}

// initial state
const initialState = {
  count: 0,
  notification: {},
} as NotificationState;

const NotificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotificationCount(init, action: { type: string; payload: number | string }) {
      const state = init;
      state.count = action.payload;
    },
    setNotification(init, action: { type: string; payload: NotificationInterface }) {
      const state = init;
      state.notification = action.payload;
    },
  },
});

// reducers exports
export const { setNotificationCount, setNotification } = NotificationSlice.actions;

export default NotificationSlice.reducer;
